import styled, { css } from 'styled-components';
import {
	media,variables
} from 'styledComponents/utils';

export const DualWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
`;


export const OTCImage = styled.div`
  height:120px;
  width: 100%;
  background-image: url(${props => props.img});
  ${props => props.type === 'topical' && 'background-image: url(https://assets.apostrophe.com/img/newCheckout/topical-product-update.png);'}
  ${props => props.type === 'oral' && css`
    background-image: url('https://assets.apostrophe.com/img/newCheckout/oral-product-update.png');
    background-position-x: -5px;
  `}
  ${props => props.type === 'sunscreen' && 'background-image: url(https://assets.apostrophe.com/img/OTCs/RET1_Apostrophe+June-2021.jpg);'}
  ${props => props.type === 'body' && css`
    background-image: url('https://assets.apostrophe.com/img/newCheckout/body-product.png');
    background-position-y: -9px;
  `}
  background-size: cover;
  position: relative;
  background-position: 0px -16px;
  ${props => props.modal && css`
    height: 58px;
    width: 50px;
    margin-right: 15px;
    ${props => !props.mobile && 'display: none;'}
    background-position: 0px 0px;
  `}
  .more-info {
    display: flex;
    position: absolute;
    width: 220px;
    bottom: 0;
    left: -20px;
    height: 35px;
    background-color: #000000;
    color: white;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.3s linear;
  }
  ${media.desktop`
    height: 180px;
    width: 180px;
    background-position: 0 -12px;
    background-size: cover;
    ${props => props.modal && css`
      height: 400px;
      width: 215px;
      margin-right: 30px;
      ${props => !props.mobile && 'display: block;'}
      ${props => props.mobile && 'display: none;'}
      background-position: -53px 0px;
    `}
  `}
`;

export const PointsWrapper = styled.ul`
  margin-top: 0;
  padding-left: 20px;
  li {
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    color: #666666;
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;

export const OTCButton = styled.div`
  width: 100%;
  padding: 11px 17.5px;
  background-color: white;
  border: 1px solid #000000;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  cursor: pointer;
	text-align: center;

	font-size: 12px;
	font-weight: 400;
	font-style: normal;
	line-height: 17px;
	letter-spacing: 0px;
	color: #000000;
	margin: 7px 0;

  ${media.desktop`
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: -0.1px;
  `}

  ${props => props.added && css`
    transition: background-color 0.3s linear;
    &:hover {
      background-color: lightgray;
    }
  `}
  ${props => props.added && css`
    background-color: rgb(245,243,242);
    border: 2px solid rgb(245,243,242);;
  `}
  ${media.desktop`
    font-size: 16px;
    margin-top: 15px;
  `}
`;

export const FlexHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  h1 {
    margin: 0 !important;
    font-size: 18px !important;
    line-height: 1 !important;
  }
  h2 {
    font-size: 14px !important;
    margin-top: 7px;
  }
`;

export const SlideWrapper = styled.div`
  height: 422px;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;

  .alice-carousel__dots {
      margin: -30px 3px 5px;
  }
  .alice-carousel__dots-item.__active {
    background-color: #000000;
  }
  .alice-carousel__dots-item {
    background-color: #999999;
  }

  ${media.desktop`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    height: 100%;
    .alice-carousel__dots {
      margin: 30px 3px 5px;
    }
  `}
`;


export const OTCWrapper = styled.div`
  padding: 20px 0;
  height: 603px;
  padding-bottom: 0;
  h3 {
    font-size: 14px;
    margin-bottom: 10px;
    text-transform: uppercase;
    font-family: 'GT-Pressura';
    ${media.desktop`
      font-size: 14px;
    `}
    span {
      font-style: italic;
      font-weight: 900;
      position: relative;
    }
  }
  hr {
    ${media.desktop`
      margin-bottom: 10px;
    `}
  }
  ${media.desktop`
    height: 100%;
  `}
`;

export const OTCCard = styled.div`
  height: 377px;
  min-width: 151px;
  max-width: 151px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(245, 243, 242);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.02);
  background-color: #F8F9F9;
  margin-bottom: 40px;
  margin-right: 10px;
  padding: 10px;
  h1 {
    font-size: 12px;
    margin-top: 6px;
    margin-bottom: 0;
    line-height: 14px;
    span {
      font-size: 10px;
      line-height: 14px;
      color: #8B8A87;
      margin-left: 5px;
    }
  }
  p {
    font-size: 10px;
    color: rgb(139 138 135);
    margin-top: 12px;
    margin-bottom: 12px;
  }
  ${media.desktop`
    min-width: 220px;
    max-width: 220px;
    height: 452px;
    margin-right: 20px;
    margin-bottom: 0;
    margin-top: 15px;
    padding: 20px;
    h1 {
      font-size: 16px;
      margin-top: 20px;
      margin-bottom: 15px;
    }
    li {
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      letter-spacing: 0px;
      color: #666666;
      margin-top: 5px;
      margin-bottom: 5px;
    }
  `}
`;

export const BetterTogether = styled.div`
  background-color: rgba(149, 207, 196, 0.17);
  padding: 15px;
  display: flex;
  justify-content: center;
  margin: 16px auto;

  ${media.tablet`
    text-align: center;
    max-width: 528px;  
  `}

  ${media.desktop`
    max-width: 100%;
  `}

  h1 {
    font-size: 18px;
    max-width: 300px;
    ${media.tablet`
      font-size: 20px;
      max-width: 425px;
    `}
    ${media.desktop`
      max-width: 600px;
    `}
  }
  p {
    font-size: 12px;
    max-width: 300px;
    margin-bottom: 0;
    margin-top: -5px;
    ${media.tablet`
      max-width: 425px;  
    `}
    ${media.desktop`
      max-width: 600px;
    `}
  }
`;

export const SaveTenWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${media.tablet`
    justify-content: center;
  `}

	h4 {
		font-size: 20px;
		margin-bottom: 10px;
	}
`;


export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #000000;
    letter-spacing: -0.10000000149011612px;
    max-width: 143px;
  }
`;

export const ContentContainer = styled.div`

`;

export const SpanContainer = styled.div`

  margin-top: 0;
  padding-left: 0px;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  color: #666666;
  margin-top: 5px;
  margin-bottom: 5px;
`;

